<template>
  <teleport to="body">
    <v-snackbar v-model="snackbarState.visible" :color="snackbarState.color" top>
      {{ snackbarState.message }}
    </v-snackbar>
  </teleport>
</template>

<script setup lang="ts">
import { useSnackbar } from '@/composables/useSnackbar';

const { snackbarState } = useSnackbar();
</script> 